<template>
  <div :class="'section-container ' + sectionType">
    <v-tabs v-if="modules.length > 1 || showBackButton" v-model="activeModuleKey">
      <v-btn v-if="showBackButton" icon @click.stop="() => $emit('setPanelState', false)" variant="text">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-tab v-if="modules.length > 1" v-for="(m, index) of modules" :key="index" :value="m.key">
        {{ $t(m.tabTitle || m.key) }}
      </v-tab>
    </v-tabs>
    <div v-for="(m, index) of modules" v-show="activeModuleKey == m.key" :class="'section-container-content ' + m.key">
      <component
        style="width: 100%; height: 100%; overflow-y: auto"
        :is="m.ViewComponent"
        v-bind="allProps(m)"
        @set-panel-state="($event) => setPanelState($event, m)"
        @set-panel-size="($event) => setPanelSize($event, m)" />
    </div>
  </div>
</template>

<script>
import { ModuleManager } from "@module-system";
import { EventManager, Actions } from "@events";

export default {
  name: "SectionContainer",
  props: {
    sectionType: {
      type: String,
      required: true,
    },
    rtcId: {
      type: String,
      required: false,
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      activeModuleKey: null,
    };
  },

  computed: {
    modules() {
      var modules = ModuleManager.getViewModules(this.sectionType, this.rtcId);
      return modules.value;
    },
  },
  watch: {
    activeModuleKey() {
      const module = this.modules.find((m) => m.key == this.activeModuleKey);
      console.log(`activeModuleKey changed: ${this.sectionType} => ${module.key}`);
      this.$emit("setPanelSize", module.size);
    },
  },
  created() {
    // register ChangeSectionModule event
    // this event is emitted by other modules to change the active module
    EventManager.getActionEmitter(this.rtcId).on(Actions.ChangeSectionModule, (action) => this.onModuleChange(action.payload));

    if (this.modules.length > 0) {
      this.activeModuleKey = this.modules[0].key;
      if (this.modules[0].size) {
        this.$emit("setPanelSize", this.modules[0].size);
      }
    } else {
      console.info(`SectionContainer: ${this.sectionType} => no modules found`);
    }
  },
  methods: {
    setPanelSize(size, module) {
      module.size = size;
      this.$emit("setPanelSize", size);
    },
    setPanelState(state) {
      this.$emit("setPanelState", state);
    },
    allProps(module) {
      return { ...this.$props, ...module.props };
    },
    onModuleChange({ section, key, state }) {
      if (section == this.sectionType) {
        var module = this.modules.find((m) => m.key == key);

        if (module) {
          if (typeof state == typeof undefined) state = true;

          console.log(`Event ${this.sectionType} ${Actions.ChangeSectionModule} => ${key}`);
          this.$emit("setPanelState", state);

          this.activeModuleKey = key;

          let activeModule = this.modules.find((m) => m.key == key);
          if (activeModule) {
            if (activeModule.size) {
              this.$emit("setPanelSize", activeModule.size);
            }
          }
        } else {
          console.warn(`Event ${Actions.ChangeSectionModule} => Module ${key} not found in section ${section}`);
        }
      }
    },
  },
};
</script>

<style>
.section-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.section-container-content {
  flex: 1;
  overflow: hidden;
}
</style>
